export const initialValues = {
  name: '',
  social_name: '',
  cnpj: '',
  description: '',
  setting_timezone: {
    id: '',
  },
  phone_checkin_disabled: false,
  tolerance_disabled: false,
  tolerance: '', // conferir
  check_out: '', // conferir
  image_url: '',
  image_data: '',
  image_info: '',
  email: '',
  cell_phone: '',
  address: {
    code_post: '',
    street: '',
    number: '',
    district: '',
    geolocation: false,
    latitude: '',
    longitude: '',
    distance: 0,
    complement: '',
    city: {
      id: '',
      name: '',
      state: {
        id: '',
        name: '',
      },
    },
  },
};
